<div class="service-order-row supplier-invoice-container">
  <form [formGroup]="fg">
    <div>
      <table class="primary-table">
        <ng-container formArrayName="grossSavings">
          <tr class="tr-saving" *ngFor="let saving of grossSavings.controls; let i = index" [formGroup]="saving">
            <td>
              <div>
                <div class="delete-saving-button" *ngIf="!disabled" (click)="removeSaving(saving, true)">
                    <img src="/content/icons/garbage.svg" height="16px">
                  {{ 'Remove saving' | translate }}
                </div>
              </div>
            </td>
            <td>
              <ng-select
                [clearable]="false"
                class="custom"
                [items]="reductionList"
                formControlName="reductionTypeCode"
                bindValue="id"
                bindLabel="name"
                [class.invalid-input]="validationError(saving.get('reductionTypeCode'))"
              >
              </ng-select>
            </td>
            <td></td>
            <td></td>
            <td>
              <div class="input-with-currency">
                <div class="input-with-currency-currency">{{ localCurrency }}</div>
                <input currencyMask [options]="currencyMaskOptions" (focus)="focusElement($event)" maxlength="15"
                       formControlName="amount" [class.invalid-input]="validationError(saving.get('amount'))" />
              </div>
            </td>

            <td>
              <div class="input-with-currency">
                <div class="input-with-currency-currency">%</div>
                <input currencyMask [options]="currencyMaskOptions" (focus)="focusElement($event)" maxlength="5"
                       formControlName="percentage" [class.invalid-input]="validationError(saving.get('percentage'))" />
              </div>
            </td>

            <td>
              <div class="input-with-currency">
                <div class="input-with-currency-currency">{{ localCurrency }}</div>
                <input currencyMask [options]="currencyMaskOptions" (focus)="focusElement($event)"
                       formControlName="totalAmount" [class.invalid-input]="validationError(saving.get('totalAmount'))" />
              </div>
            </td>
          </tr>
        </ng-container>
        <tr class="tr-service">
          <td class="td-service-order">
            <ng-select
              class="custom"
              formControlName="serviceOrderId"
              [items]="serviceOrderItems"
              bindValue="serviceOrderId"
              bindLabel="serviceOrderType"
              [clearable]="false"
              [class.invalid-input]="validationError(fg.get('serviceOrderId'))"
            >
              <ng-template ng-label-tmp let-item="item">
                <div *ngIf="!!item.serviceOrderType">
                  <img [src]="item.iconFileName()" class="service-order-icon" />
                  <div class="service-order-type">
                    {{ item.serviceTypeName }} {{ item.isServiceOrder ? '- ' + item.serviceOrderId : '' }}
                  </div>
                  <div class="service-order-provider">{{ item.providerName }}</div>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                <img [src]="item.iconFileName()" class="service-order-icon" />
                <div class="service-order-type">{{ item.serviceTypeName }} {{ item.isServiceOrder ? '- ' + item.serviceOrderId : '' }}</div>
                <div class="service-order-provider">{{ item.providerName }}</div>
              </ng-template>
            </ng-select>
          </td>
          <td class="td-item">
            <ng-select
              class="custom"
              [items]="serviceItemList"
              formControlName="serviceItemCode"
              bindValue="id"
              bindLabel="name"
              [clearable]="false"
              [class.invalid-input]="validationError(fg.get('serviceItemCode'))"
            >
            </ng-select>
          </td>
          <td class="td-quantity">
              <input currencyMask [options]="currencyMaskOptions" (focus)="focusElement($event)" (blur)="onTouched()"
                     formControlName="quantity" [class.invalid-input]="validationError(fg.get('quantity'))" />
          </td>
          <td class="td-unit">
            <ng-select
              [clearable]="false"
              class="custom"
              [items]="quantityUnits"
              formControlName="quantityUnit"
              bindValue="id"
              bindLabel="name"
              [class.invalid-input]="validationError(fg.get('quantityUnit'))"
            >
            </ng-select>
          </td>
          <td class="td-savings-amount"></td>
          <td class="td-savings-pct"></td>
          <td class="td-amount">
            <div class="input-with-currency">
              <div class="input-with-currency-currency">{{ localCurrency }}</div>
              <input currencyMask [options]="currencyMaskOptions" (focus)="focusElement($event)" (blur)="onTouched()" maxlength="20"
                     formControlName="paidAmount" [class.invalid-input]="validationError(fg.get('paidAmount'))" />
            </div>
          </td>
        </tr>
        <ng-container formArrayName="netSavings">
          <tr class="tr-saving" *ngFor="let saving of netSavings.controls; let i = index" [formGroup]="saving">
            <td>
              <div>
                <div class="delete-saving-button" *ngIf="!disabled" (click)="removeSaving(saving, false)">
                    <img src="/content/icons/garbage.svg" height="16px">
                  {{ 'Remove saving' | translate }}
                </div>
              </div>
            </td>
            <td>
              <ng-select
                [clearable]="false"
                class="custom"
                [items]="reductionList"
                formControlName="reductionTypeCode"
                bindValue="id"
                bindLabel="name"
                [class.invalid-input]="validationError(saving.get('reductionTypeCode'))"
              >
              </ng-select>
            </td>
            <td></td>
            <td></td>
            <td>
              <div class="input-with-currency">
                <div class="input-with-currency-currency">{{ localCurrency }}</div>
                <input currencyMask [options]="currencyMaskOptions" (focus)="focusElement($event)" maxlength="15"
                       formControlName="amount" [class.invalid-input]="validationError(saving.get('amount'))" />
              </div>
            </td>
            <td>
              <div class="input-with-currency">
                <div class="input-with-currency-currency">%</div>
                <input currencyMask [options]="currencyMaskOptions" (focus)="focusElement($event)" maxlength="5"
                       formControlName="percentage" [class.invalid-input]="validationError(saving.get('percentage'))" />
              </div>
            </td>
            <td>
              <div class="output-with-currency">
                <div class="output-with-currency-currency">{{ localCurrency }}</div>
                {{ getTotalAmountSaving(saving) | numberFormat }}
              </div>
            </td>
          </tr>
        </ng-container>
        <tr class="tr-saving">
          <td class="td-add-saving-left"></td>
          <td class="td-add-saving">
            <div class="add-saving-container">
              <div class="add-saving-button text-nowrap" *ngIf="!disabled && !hideSavingButtons" (click)="addSaving(false)">
                <fa-icon icon="plus"></fa-icon>
                {{ 'Add saving' | translate }}
              </div>
              <div class="add-saving-button text-nowrap" *ngIf="!disabled && !hideSavingButtons" (click)="addSaving(true)">
                <fa-icon icon="plus"></fa-icon>
                {{ 'Add gross saving' | translate }}
              </div>
            </div>
          </td>

          <td class="td-add-saving"></td>
          <td class="td-add-saving-right"></td>
          <td>
            <div class="output-with-currency">
              <div class="output-with-currency-currency">{{ localCurrency }}</div>
              {{ getSavingsAmountTotal() | numberFormat }}
            </div>
          </td>
          <td>
            <div class="output-with-currency">
              <div class="output-with-currency-currency">%</div>
              {{ getSavingsPctTotal() | numberFormat }}
            </div>
          </td>
          <td>
            <div class="output-with-currency">
              <div class="output-with-currency-currency">{{ localCurrency }}</div>
              {{ getNetAmount() | numberFormat }}
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="delete-button" *ngIf="showDelete && !disabled" (click)="deleteSpecification()">
        <img src="/content/icons/garbage.svg" height="16px">
    </div>
  </form>
</div>
